// @flow
import React, {Component} from 'react'; 
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import {Default, Mobile} from '../../../../utils/responsive';
import {FormValidator} from '../../../../utils/form/index';
import analytics from '../../../../analytics';
import {urlVerifier} from '../../../../utils/string';
 
import style from './BottomHomeSearch.scss'; 
import buttonStyle from '../../../../assets/styles/button.scss';
import inputStyle from '../../../../assets/styles/input.scss';

import manDesktop from '../../../../assets/img/home/bottom-home-search/man-desktop.png';
import warrantyIcon from '../../../../assets/img/home/bottom-home-search/warranty-icon.png';
import paymentIcon from '../../../../assets/img/home/bottom-home-search/payment-icon.png';
import clockIcon from '../../../../assets/img/home/bottom-home-search/clock-icon.png';

import type {FormValidationResult} from '../../../../utils/form';
import type {LocaleState} from '../../../locale/duck';

type Props = {
  +goToRedirect: (route: string) => void;
  +locale: LocaleState;
};

type State = {
  url: {
    value: string;
    errors?: string[];
  }; 
};
 
const listCard = [
  {
    text: 'Garantía de 90 días',
    icon: warrantyIcon,
  },
  {
    text: 'Paga hasta en 3 cuotas sin intereses',
    icon: paymentIcon,
  },
  {
    text: 'Rápido y sin trámites',
    icon: clockIcon,
  }
];

export default class BottomHomeSearch extends Component<Props, State> {
  formValidator: FormValidator;
  state = {
    url: {
      value: '',
    }, 
  };

  constructor(props: Props) {
    super(props);
    this.formValidator = new FormValidator({
      url: {
        required: 'required',
      },
    });
  }

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const {goToRedirect, locale} = this.props;
    const {url} = this.state;
    const errors = this.formValidator.validateForm({
      url: url.value,
    });

    analytics.fireCustomEvent('Home Main Button Clicked', {
      category: 'Home Main Button',
      action: 'Clicked',
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      url: url.value || '',
      domain_country: locale.domainCountry,
    });

    if (errors.length) {
      errors.forEach(
        (error: FormValidationResult) =>
          this.setState(
            (state: State) => ({
                [error.field]: {
                  ...state[error.field],
                  errors: error.errors,
                },
              }
            )),
      );
    } else {
      if (urlVerifier(url.value) || url.value.startsWith('http')) {
        goToRedirect(`/new-order/product?initialQuery=${url.value}`);
      } else {
        goToRedirect(`/new-order/search?name=${url.value}`);
      }
    }
    return false;
  };
  
  handleFocus = (e: Event) => {
    this.setState((s: State)=> ({
      url: {value: s.url.value}
    }));
  }

  handleBlur = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const { value} = e.target;
      const errors = this.formValidator.validateField('url', value);
      if (errors.length && (errors[0] === 'urlFormat')) {
        this.setState({url: {value, errors}});
      } else {
        this.setState({url: {value}});
      }
    }
  }

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const {name, value} = e.target;
      this.setState({url: {value}});
    }
  }
 
  render() {
    const {url} = this.state;

    return (
      <div className={style.bottomHomeSearchWrap}>
        <div className={style.mainWrap}>
          
          <div className={style.leftWrap}>
              <img src={manDesktop} alt="image"/>
          </div>

          <div className={style.rightWrap}>
            <div className={style.containerWrap}>
               <form className={style.formWrap} 
                action="/new-order/product"
                onSubmit={this.handleSubmit}
              >
                {/*<h1 className={style.title}>Compra en USA sin trámites.</h1>*/}
                <h1 className={style.title}>Compra en USA sin impuestos con los viajeros de Qempo</h1>
                <div className={style.cardWrap}>
                  <div className={style.itemCard}>
                    <span>Garantía de 90 días</span>
                    <img src={warrantyIcon} alt=""/>
                  </div>
                  <div className={classNames(style.itemCard,style.hidden)}>
                    <span>Paga hasta en 3 cuotas sin intereses</span>
                    <img src={paymentIcon} alt=""/>
                  </div>
                  <div className={classNames(style.itemCard,style.hidden)}>
                    <span>Rápido y sin trámites</span>
                    <img src={clockIcon} alt=""/>
                  </div>

                </div>
                <label className={style.inputLabel}>Busca el producto en la tienda de USA y pega el link o ingresa el nombre:</label>
                <section className={style.inputWrap}>
                  <input 
                    placeholder="Ej: www.tienda.com/producto"
                    type="text"
                    name="initialQuery"
                    className={classNames(inputStyle.input, style.input,
                      {[inputStyle.red]: url.errors && url.errors.length})}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                  />
                  <button  
                    type="submit"
                    className={classNames(buttonStyle.btn,
                    buttonStyle.orange,
                    style.button)}>Cotizar GRATIS</button>
                </section>
              </form> 
            </div>
          </div>   
        </div>
      </div>
    );
  }
}


BottomHomeSearch.propTypes = { 
  goToRedirect: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/home/elements/BottomHomeSearch/BottomHomeSearch.jsx